import { render, staticRenderFns } from "./Produit_PleinePage.vue?vue&type=template&id=65f450b6&scoped=true&"
import script from "./Produit_PleinePage.vue?vue&type=script&lang=js&"
export * from "./Produit_PleinePage.vue?vue&type=script&lang=js&"
import style0 from "./Produit_PleinePage.vue?vue&type=style&index=0&id=65f450b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f450b6",
  null
  
)

export default component.exports